<template>
  <div>
    <div class="row">

      <div class="col-md-12 co-12">
        <b-card title="Lista de Matriz">

          <b-row>

            <b-col md="12" sm="12" class="my-1">
              <div class="demo-inline-spacing">
                <b-button
                    :href="url_base + '/media/file_medidas/formato_carga_masiva/registro_matriz.xlsx'"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'" size="sm" variant="secondary">
                  <a style="color:white;">
                    <feather-icon icon="DownloadIcon" />
                    <span> Descargar Formato Subida</span>
                  </a>
                </b-button>
                <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" size="sm" variant="secondary"
                          v-on:click="descargarCategoriasSubCategorias()">
                  <a style="color:white;">
                    <feather-icon icon="DownloadIcon" />
                    <span> Descargar Categorias y Sub Categorias</span>
                  </a>
                </b-button>
                <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" size="sm" variant="secondary"
                          v-on:click="descargarTipoSancion()">
                  <a style="color:white;">
                    <feather-icon icon="DownloadIcon" />
                    <span> Descargar Tipos de Sanción</span>
                  </a>
                </b-button>
              </div>
            </b-col>

            <b-col md="4" sm="4" class="my-1">
              <b-input-group>
                <b-input-group-prepend>
                  <b-form-file v-model="fileExcel" id="archivoExcel" accept=".xlsx"
                               placeholder="Ningún archivo elegido" browse-text="Excel" @change="leerFile" />
                </b-input-group-prepend>

                <b-input-group-append>
                  <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" v-on:click="resetFile()"
                            size="sm" variant="warning">
                    Resetear
                  </b-button>
                </b-input-group-append>

                <b-input-group-append>
                  <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                            v-on:click="subirDatosServidor()" size="sm" variant="primary">
                    Subir Datos
                  </b-button>
                </b-input-group-append>

              </b-input-group>
            </b-col>

            <b-col md="3" class="my-1">
              <template v-if="matriz.length !== 0">
                <div>
                  <h5 v-if="fila !== matriz.length">Cargando... {{fila}} de {{matriz.length}}</h5>
                  <h5 v-if="fila === matriz.length && filanoguardada === 0">
                    <b-badge pill variant="success" >
                      Carga completada
                    </b-badge>
                  </h5>
                  <h5 v-if="filanoguardada !== 0">
                    <b-badge pill variant="danger" >
                      Fila Nro {{filanoguardada}} en adelante del Excel, no se registró
                    </b-badge>
                  </h5>
                </div>

                <b-progress :max="matriz.length">
                  <b-progress-bar :value="fila" :label="`${((fila / matriz.length) * 100).toFixed(2)} %`"></b-progress-bar>
                </b-progress>
              </template>
            </b-col>

            <b-col md="5" class="my-1">
              <b-form-group label="Buscar" label-cols-sm="3" label-align-sm="right" label-size="sm"
                            label-for="filterInput" class="mb-0">
                <b-input-group size="sm">
                  <b-form-input id="filterInput" v-model="filter" type="search"
                                placeholder="Escribe para buscar" />
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-table ref="selectableTable" small="small" responsive :per-page="perPage"
                       :current-page="currentPage" :items="matriz" :fields="fieldsMatriz"
                       :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection"
                       :filter="filter" :filter-included-fields="filterOn" @filtered="onFilteredMatriz"
                       :busy="cargandoMatriz" show-empty>

                <template #empty="scope">
                  <div role="alert" aria-live="polite">
                    <div class="text-center my-2">No hay registros para mostrar</div>
                  </div>
                </template>
                <template #emptyfiltered="scope">
                  <div role="alert" aria-live="polite">
                    <div class="text-center my-2">No hay registros que coincidan con su solicitud
                    </div>
                  </div>
                </template>

                <template #table-busy>
                  <div class="text-center text-dark my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong> Cargando...</strong>
                  </div>
                </template>

              </b-table>
            </b-col>

            <b-col md="7" sm="8" class="my-1">
              <b-form-group class="mb-0">
                <label class="d-inline-block text-sm-left mr-50">Por Página</label>
                <b-form-select id="perPageSelect" v-model="perPage" size="sm"
                               :options="pageOptions" class="w-50" />
              </b-form-group>
            </b-col>

            <b-col md="5" class="my-1">
              <b-pagination v-model="currentPage" :total-rows="totalRowsMatriz"
                            :per-page="perPage" align="center" size="sm" class="my-0" />
            </b-col>

          </b-row>

        </b-card>
      </div>

    </div>
  </div>

</template>



<script>

import axiosIns from '../../../libs/axios'
import Ripple from 'vue-ripple-directive'
import moment from 'moment'
import {
  BCard, BButton, BRow, BCol, BFormGroup, BInputGroupPrepend, BInputGroup, BFormDatepicker,
  BFormInput, BInputGroupAppend, BFormSelect, BTable, BPagination, BBadge, BCardText,
  BSpinner, BForm, BAvatar, BTabs, BTab, BFormFile, BListGroup, BListGroupItem, BProgress, BProgressBar,
} from 'bootstrap-vue'
import Swal from 'sweetalert2'
import readXlsFile from "read-excel-file";

export default {
  components: {
    BCard, BButton, BRow, BCol, BFormGroup, BInputGroupPrepend, BInputGroup, BFormDatepicker,
    BFormInput, BInputGroupAppend, BFormSelect, BTable, BPagination, BBadge, BCardText,
    BSpinner, BForm, BAvatar, BTabs, BTab, BFormFile, BListGroup, BListGroupItem, BProgress, BProgressBar,
    Swal

  },
  directives: {
    Ripple,
  },
  data() {
    return {
      fila: 0,

      categoriasysubcategorias: [],
      fileExcel: [],
      matriz: [],
      filter: null,

      perPage: 5,
      currentPage: 1,
      fieldsMatriz: [
        { key: '27', label: 'NRO FILA EXCEL', sortable: true, stickyColumn: true, isRowHeader: true },
        { key: '0', label: 'ID CATEGORIA', sortable: true },
        { key: '1', label: 'DESCRIPCION CATEGORIA', sortable: true },
        { key: '2', label: 'ID SUB CATEGORIA', sortable: true },
        { key: '3', label: 'DESCRIPCION SUB CATEGORIA', sortable: true },
        { key: '4', label: 'NRO ARTICULO', sortable: true },
        { key: '5', label: 'DESCRIPCION ARTICULO', sortable: true },
        { key: '6', label: 'NRO INCISO', sortable: true },
        { key: '7', label: 'DESCRIPCION INCISO', sortable: true },
        { key: '8', label: 'SUPUESTO', sortable: true },
        { key: '9', label: 'ESTADO MATRIZ', sortable: true },
        { key: '10', label: 'TIPO', sortable: true },
        { key: '11', label: 'ID TIPO SANCION (GRADUALIDAD 1)', sortable: true },
        { key: '12', label: 'DESCRIPCION TIPO SANCION (GRADUALIDAD 1)', sortable: true },
        { key: '13', label: 'CANT DIAS (GRADUALIDAD 1)', sortable: true },
        { key: '14', label: 'ID TIPO SANCION (GRADUALIDAD 2)', sortable: true },
        { key: '15', label: 'DESCRIPCION TIPO SANCION (GRADUALIDAD 2)', sortable: true },
        { key: '16', label: 'CANT DIAS (GRADUALIDAD 2)', sortable: true },
        { key: '17', label: 'ID TIPO SANCION (GRADUALIDAD 3)', sortable: true },
        { key: '18', label: 'DESCRIPCION TIPO SANCION (GRADUALIDAD 3)', sortable: true },
        { key: '19', label: 'CANT DIAS (GRADUALIDAD 3)', sortable: true },
        { key: '20', label: 'ID TIPO SANCION (GRADUALIDAD 4)', sortable: true },
        { key: '21', label: 'DESCRIPCION TIPO SANCION (GRADUALIDAD 4)', sortable: true },
        { key: '22', label: 'CANT DIAS (GRADUALIDAD 4)', sortable: true },
        { key: '23', label: 'MEDIOS PROBATORIOS', sortable: true },
        { key: '24', label: 'OBSERVACION', sortable: true },
        { key: '25', label: 'RESPONSABLE', sortable: true },
        { key: '26', label: 'ERRORES DE SUBIDA', sortable: true },
      ],
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filterOn: [],
      totalRowsMatriz: 1,
      cargandoMatriz: false,

      categorias: [],
      subcategorias: [],
      tipossancion: [],
      listmatriz: [],
      canterrores: 0,
      url_base: '',

      pageOptions: [3, 5, 10],

      filaguardar: 0,
      filanoguardada: 0,
    }
  },
  methods: {
    resetFile() {
      this.fileExcel = [];
      this.matriz = [];
      this.fila = 0;
      this.filaguardar = 0;
      this.filanoguardada = 0;
    },
    leerFile(evento) {
      this.matriz = [];
      if (evento.target.files[0] !== undefined) {
        readXlsFile(evento.target.files[0]).then((rows) => {

          this.canterrores = 0

          rows.forEach((row, index2) => {
            if (index2 !== 0) {
              let nro_fila = index2+1;
              let errores = this.encontrarErrores(row)
              if (errores.length !== 0) {
                this.canterrores++
              }
              console.log(errores)
              row.push(errores)
              row.push(nro_fila)
              this.matriz.push(row)
            }
          })

          this.totalRowsMatriz = this.matriz.length
        })


      }
      //this.subcategorias
      //console.log(this.matriz);
    },
    encontrarErrores(row) {
      let errores = ""

      let arrayMatrizTemporal = []
      this.listmatriz.forEach((subcategoria, index1) => {
        if (Number(subcategoria.categoria) === Number(row[0]) && Number(subcategoria.id) === Number(row[2])) {
          arrayMatrizTemporal.push(subcategoria)
        }
      })

      if (arrayMatrizTemporal.length !== 0) {
        errores = errores + " | " + "Verificar categoria o sub categoria, relación ya se encuentra registrada"
      }

      let arrayCatTemporal = []
      this.subcategorias.forEach((subcategoria, index1) => {
        if (Number(subcategoria.categoria) === Number(row[0]) && Number(subcategoria.id) === Number(row[2])) {
          arrayCatTemporal.push(subcategoria)
        }
      })

      if (arrayCatTemporal.length === 0) {
        errores = errores + " | " + "Verificar categoria o sub categoria, no tiene relación"
      }

      let arrayTipoSancTemporal_1 = []
      this.tipossancion.forEach((tiposancion, index1) => {
        if (Number(tiposancion.id) === Number(row[11])) {
          arrayTipoSancTemporal_1.push(tiposancion)
        }
      })
      if (arrayTipoSancTemporal_1.length === 0) {
        errores = errores + " | " + "Verificar ID de tipo de sancion (GRADUALIDAD 1)"
      }

      let arrayTipoSancTemporal_2 = []
      this.tipossancion.forEach((tiposancion, index1) => {
        if (Number(tiposancion.id) === Number(row[14])) {
          arrayTipoSancTemporal_2.push(tiposancion)
        }
      })
      if (arrayTipoSancTemporal_2.length === 0) {
        errores = errores + " | " + "Verificar ID de tipo de sancion (GRADUALIDAD 2)"
      }

      let arrayTipoSancTemporal_3 = []
      this.tipossancion.forEach((tiposancion, index1) => {
        if (Number(tiposancion.id) === Number(row[17])) {
          arrayTipoSancTemporal_3.push(tiposancion)
        }
      })
      if (arrayTipoSancTemporal_3.length === 0) {
        errores = errores + " | " + "Verificar ID de tipo de sancion (GRADUALIDAD 3)"
      }

      let arrayTipoSancTemporal_4 = []
      this.tipossancion.forEach((tiposancion, index1) => {
        if (Number(tiposancion.id) === Number(row[20])) {
          arrayTipoSancTemporal_4.push(tiposancion)
        }
      })
      if (arrayTipoSancTemporal_4.length === 0) {
        errores = errores + " | " + "Verificar ID de tipo de sancion (GRADUALIDAD 4)"
      }


      if (isNaN(row[13])) {
        errores = errores + " | " + "Verificar cant dias (GRADUALIDAD 1), no es un numero"
      } else {
        if (row[13] % 1 === 0) {
          // Es un numero entero
        } else {
          errores = errores + " | " + "Verificar cant dias (GRADUALIDAD 1), no es un numero entero"
        }
      }

      if (isNaN(row[16])) {
        errores = errores + " | " + "Verificar cant dias (GRADUALIDAD 2), no es un numero"
      } else {
        if (row[16] % 1 === 0) {
          // Es un numero entero
        } else {
          errores = errores + " | " + "Verificar cant dias (GRADUALIDAD 2), no es un numero entero"
        }
      }

      if (isNaN(row[19])) {
        errores = errores + " | " + "Verificar cant dias (GRADUALIDAD 3), no es un numero"
      } else {
        if (row[19] % 1 === 0) {
          // Es un numero entero
        } else {
          errores = errores + " | " + "Verificar cant dias (GRADUALIDAD 3), no es un numero entero"
        }
      }

      if (isNaN(row[22])) {
        errores = errores + " | " + "Verificar cant dias (GRADUALIDAD 4), no es un numero"
      } else {
        if (row[22] % 1 === 0) {
          // Es un numero entero
        } else {
          errores = errores + " | " + "Verificar cant dias (GRADUALIDAD 4), no es un numero entero"
        }
      }

      return errores;
    },
    onFilteredMatriz(filteredItems) {
      this.totalRowsMatriz = filteredItems.length
      this.currentPage = 1
    },
    obtenerCategorias() {
      this.categorias = [];

      const config = {
        method: 'get',
        url: '/sap/md/categoria/list/',
      };

      axiosIns(config)
          .then((response) => {
            if (response.status === 200) {
              this.categorias = response.data;
            }
          })
          .catch((error) => {
            //console.log(error);
            console.log("=======error=======");
            this.obtenerCategorias();
          });
    },
    obtenerCategoriasySubCategorias() {
      this.categoriasysubcategorias = [];

      var config = {
        method: 'post',
        url: '/sap/md/categoria/listcategoriasubcategoria/'
      };

      axiosIns(config)
          .then((response) => {
            if (response.status === 200) {
              this.categoriasysubcategorias = response.data.response;
            }
          })
          .catch((error) => {
            console.log("=======error=======");
            this.obtenerCategoriasySubCategorias();
          });

    },
    obtenerSubCategorias() {
      this.subcategorias = [];

      const config = {
        method: 'get',
        url: '/sap/md/subcategoria/list/',
      };

      axiosIns(config)
          .then((response) => {
            if (response.status === 200) {
              this.subcategorias = response.data;
              //console.log(this.subcategorias);
            }
          })
          .catch((error) => {
            //console.log(error);
            console.log("=======error=======");
            this.obtenerSubCategorias();
          });
    },
    obtenerTipoSancion() {
      this.tipossancion = [];

      const config = {
        method: 'get',
        url: '/sap/md/mdtiposancion/list/',
      };

      axiosIns(config)
          .then((response) => {
            if (response.status === 200) {
              this.tipossancion = response.data;
            }
          })
          .catch((error) => {
            //console.log(error);
            console.log("=======error=======");
            this.obtenerTipoSancion();
          });
    },
    obtenerMatriz() {
      this.listmatriz = [];

      const config = {
        method: 'get',
        url: '/sap/md/mdmatriz/list/',
      };

      axiosIns(config)
          .then((response) => {
            if (response.status === 200) {
              this.listmatriz = response.data;
            }
          })
          .catch((error) => {
            //console.log(error);
            console.log("=======error=======");
            this.obtenerMatriz();
          });
    },
    iniciarfunciones() {
      this.obtenerCategorias()
      this.obtenerCategoriasySubCategorias()
      this.obtenerSubCategorias()
      this.obtenerTipoSancion()
      this.obtenerMatriz()
    },
    subirDatosServidor() {

      if (this.canterrores !== 0) {
        this.errorRegistro('Existen errores al cargar el archivo, ');
      } else {

        this.fila = this.filaguardar+1;
        let counter = 0;
        while( counter <= this.matriz.length){

          if(counter === this.filaguardar ){
            this.crearMatriz(this.matriz[this.filaguardar])
          }
          counter++;

        }

        /*this.matriz.forEach((matrizexcel, index) => {
            this.crearMatriz(matrizexcel)
        })

        this.matriz = [];
        this.iniciarfunciones();*/
      }
    },
    crearMatriz(matrizexcel) {

      var fechaActual = moment().format('YYYY-MM-DD H:mm:ss');

      var data = {
        "categoria": matrizexcel[0],
        "subcategoria": matrizexcel[2],
        "nro_articulo": matrizexcel[4],
        "articulo": matrizexcel[5],
        "nro_inciso": matrizexcel[6],
        "inciso": matrizexcel[7],
        "supuesto": matrizexcel[8],
        "estado_matriz": matrizexcel[9],
        "tipo": matrizexcel[10],
        "tipo_sancion_1": matrizexcel[11],
        "cant_dias_1": matrizexcel[13],
        "tipo_sancion_2": matrizexcel[14],
        "cant_dias_2": matrizexcel[16],
        "tipo_sancion_3": matrizexcel[17],
        "cant_dias_3": matrizexcel[19],
        "tipo_sancion_4": matrizexcel[20],
        "cant_dias_4": matrizexcel[22],
        "medios_probatorios": matrizexcel[23],
        "observacion": matrizexcel[24],
        "responsable": matrizexcel[25],
        "fecha_creacion": fechaActual,
        "fecha_actualizacion": fechaActual,
        "estado": "1"
      };

      var config = {
        method: 'post',
        url: '/sap/md/mdmatriz/crear/',
        data: data
      };

      axiosIns(config)
          .then((response) => {
            //this.makeToast('success', matrizexcel[8]);
            if(response.status === 201){
              if(this.filaguardar < this.matriz.length-1){
                this.filaguardar++;
                this.subirDatosServidor();
              }
            }
          })
          .catch((error) => {
            //this.makeToast('danger', matrizexcel[8]);
            this.makeToast('danger', matrizexcel[27]);
            this.filanoguardada = matrizexcel[27];
          });


    },
    errorRegistro(texto) {
      Swal.fire({
        title: 'Error!',
        text: texto + ' Registro fallido',
        icon: 'error',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
    },
    makeToast(variant, nrofila) {
      if (variant === 'success') {
        this.$bvToast.toast('Fila Nro ' + nrofila, {
          title: 'Registro exitoso',
          variant,
          solid: true,
        })
      }

      if (variant === 'danger') {
        this.$bvToast.toast('Fila Nro ' + nrofila+' en adelante del Excel, no se registró', {
          title: 'Registro fallido',
          variant,
          solid: true,
        })
      }

    },
    descargarCategoriasSubCategorias() {

      var config = {
        method: 'post',
        url: '/sap/md/categoria/descargarexcel/',
        responseType: 'arraybuffer'
      };

      axiosIns(config)
          .then((response) => {
            if (response.status === 200) {
              const fileURL = window.URL.createObjectURL(new Blob([response.data]));
              console.log(fileURL);
              const fileLink = document.createElement('a');
              fileLink.href = fileURL;
              fileLink.setAttribute('download', "lista_categorias_subcategorias.xlsx");
              document.body.appendChild(fileLink);
              fileLink.click();
            }
          })
          .catch((error) => {
            console.log(error);
          });

    },
    descargarTipoSancion() {

      var config = {
        method: 'post',
        url: '/sap/md/mdtiposancion/descargarexcel/',
        responseType: 'arraybuffer'
      };

      axiosIns(config)
          .then((response) => {
            if (response.status === 200) {
              const fileURL = window.URL.createObjectURL(new Blob([response.data]));
              console.log(fileURL);
              const fileLink = document.createElement('a');
              fileLink.href = fileURL;
              fileLink.setAttribute('download', "lista_tipo_sancion.xlsx");
              document.body.appendChild(fileLink);
              fileLink.click();
            }
          })
          .catch((error) => {
            console.log(error);
          });

    }
  },
  created() {
    this.url_base = 'https://www.agvperu.com/backend';
    //this.url_base = 'http://localhost:7000';
    this.iniciarfunciones();

  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
